export default __webpack_public_path__ + "static/media/pacakgeModal2.11a4ae33.png";